/**
 * AiLabel.tsx
 * Sichtbare Kennzeichnung KI-generierter Bild-/Videoinhalte nach
 * Art. 50 Abs. 4 Verordnung (EU) 2024/1689 (KI-VO).
 *
 * Einsatz: als letztes Kind des naechsten position:relative-Containers des Bildes.
 * Position per Custom Property ueberschreibbar:
 *   <AiLabel tone="dark" style={{ "--eg-ai-label-bottom": "8px" }} />
 */
import type { CSSProperties } from "react";
import { useLanguage } from "@/contexts/LanguageContext";
import "./ai-label.css";

interface AiLabelProps {
  /** dark/auto: weisse Schrift auf opaker Platte · light: dunkle Schrift ohne Platte */
  tone?: "light" | "dark" | "auto";
  className?: string;
  style?: CSSProperties;
}

const AiLabel = ({ tone = "auto", className = "", style }: AiLabelProps) => {
  const { t } = useLanguage();

  return (
    <span className={`eg-ai-label eg-ai-label--${tone} ${className}`.trim()} style={style}>
      {t("journey.aiLabel.short")}
    </span>
  );
};

export default AiLabel;
